import { useState, useMemo } from 'react'
import type { Dispute } from '../types/dispute.types'
import { mockDisputes } from '../data/mockDisputes'

export const useDisputes = () => {
    const [disputes] = useState<Dispute[]>(mockDisputes)
    const [searchText, setSearchText] = useState('')
    const [statusFilter, setStatusFilter] = useState('all')
    const [priorityFilter, setPriorityFilter] = useState('all')

    const filteredDisputes = useMemo(() => {
        let filtered = disputes

        if (statusFilter !== 'all') {
            filtered = filtered.filter(d => d.status === statusFilter)
        }

        if (priorityFilter !== 'all') {
            filtered = filtered.filter(d => d.priority === priorityFilter)
        }

        if (searchText) {
            const lowerSearch = searchText.toLowerCase()
            filtered = filtered.filter(d => 
                d.id.toLowerCase().includes(lowerSearch) ||
                d.subject.toLowerCase().includes(lowerSearch) ||
                d.customer.toLowerCase().includes(lowerSearch)
            )
        }

        return filtered
    }, [disputes, searchText, statusFilter, priorityFilter])

    return {
        disputes: filteredDisputes,
        searchText,
        setSearchText,
        statusFilter,
        setStatusFilter,
        priorityFilter,
        setPriorityFilter
    }
}
